<template>
  <div class="approval-container">
    <van-nav-bar title="大宗原料行情审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">基本信息</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="attachment" v-if="attachList.length">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">附件信息</span>
        </template>
        <hi-attachment :attach-list="attachList"></hi-attachment>
      </van-collapse-item>
      <van-collapse-item name="detailList">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">行情明细</span>
        </template>
        <detail-list :details-list="detailsList" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { selectInfoById } from '@/api/pmCommodityQuotationApply'
import Bridge from '@/components/dsbridge'

export default {
  name: 'CommodityQuotationApplyApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'detail-list': () => import('./components/DetailList.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      headInfo: {},
      detailsList: [],
      attachList: [],
      businessKey: this.$route.query.businessKey
    }
  },
  computed: {
    thisPage() {
      return this
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      const headResp = await selectInfoById(this.businessKey)
      this.headInfo = headResp.data || {}
      this.detailsList = this.headInfo.pmCommodityQuotationItems || []
      this.attachList = this.headInfo.attachmentFiles || []
    },
    onClickLeft() {
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
